module.exports = __webpack_public_path__ + "static/media/lilPurple.d23e2f52.JPG";